import React from 'react';
import { Star, Shield } from 'lucide-react';

const SocialProofRow = () => {
  return (
    <section className="py-8 bg-blue-50 border-y border-blue-200">
      <div className="max-w-6xl mx-auto px-6">
        <div className="flex flex-col lg:flex-row items-center justify-center space-y-6 lg:space-y-0 lg:space-x-12">
          {/* Star Rating */}
          <div className="flex flex-col items-center">
            <div className="flex items-center mb-2">
              {[...Array(5)]?.map((_, i) => (
                <Star key={i} className="w-6 h-6 text-yellow-500 fill-current" />
              ))}
            </div>
            <div className="text-sm text-gray-600 text-center">
              <strong>4.9/5 Stars</strong><br/>
              Based on 500+ reviews
            </div>
          </div>

          {/* Licensed Badge */}
          <div className="flex flex-col items-center">
            <div className="flex items-center mb-2">
              <Shield className="w-8 h-8 text-green-600 mr-2" />
              <span className="text-lg font-black text-green-700">Licensed</span>
            </div>
            <div className="text-sm text-gray-600 text-center">
              <strong>15+ Years</strong><br/>
              Sacramento Service
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SocialProofRow;